import { SUNRUN_ORG_ID } from "@remi/constants";
import { REMI_INTERNAL_ORG } from "@remi/types/organizations";

import { useUserProfile } from "~/contexts/UserProfileContext";

export const useUserOrgType = () => {
  const { user } = useUserProfile();

  const isSunrunUser = user.person.organizationId === SUNRUN_ORG_ID;
  const isRemiUser = user.person.organizationId === REMI_INTERNAL_ORG.id;

  return { isSunrunUser, isRemiUser };
};
